import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { header } from './header.vanilla.mjs';

const ModalHeader = forwardRef(
  ({ className: classNameFromProps, ...props }, ref) => {
    const className = classNames(header, classNameFromProps);
    return /* @__PURE__ */ jsx(
      StyledHeader,
      {
        "data-scope": "modal",
        "data-part": "header",
        className,
        ref,
        ...props
      }
    );
  }
);
ModalHeader.toString = () => '[data-scope="modal"][data-part="header"]';
const StyledHeader = styled("header");

export { ModalHeader };
//# sourceMappingURL=Header.mjs.map
